import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import './navigation-button.css';

const NavigationButton = ({ isEnabled, onClick, label }) => {
  return (
    <button 
      className={`navigation-button ${!isEnabled ? 'disabled' : ''}`}
      onClick={onClick}
      disabled={!isEnabled}
    >
      <span className="button-text">{label}</span>
      <FaChevronRight className="button-icon" />
    </button>
  );
};

export default NavigationButton;